import "../packs_common/globalFunctions"

import CookieConsentDialog from "../components/CookieConsentDialog"
import TranslationsHandler from "../components/TranslationsHandler"
import Translations from "../components/Translations"
import FriendReferral from "../components/FriendReferral"
import FriendReferralReceiver from "../components/FriendReferral/receiver"
import FriendReferralCompact from '../components/FriendReferral/referalCompact'
import { FunctionComponent } from 'react'
import ReactOnRails from "../reactOnRails"
import AmexDone from "../components/amex/done"

declare global {
    interface Window { 
        TranslationsHandler: TranslationsHandler,
        socialSharer: (url: string, description: string, type: string) => string,
        dataLayer: object[]
    }
}
  
window.TranslationsHandler = TranslationsHandler

ReactOnRails.register({ "FriendReferral": FriendReferral as FunctionComponent })
ReactOnRails.register({ "FriendReferralCompact": FriendReferralCompact as FunctionComponent })
ReactOnRails.register({ "FriendReferralReceiver": FriendReferralReceiver as FunctionComponent })
ReactOnRails.register({ "Translations": Translations as FunctionComponent })
ReactOnRails.register({ "CookieConsentDialog": CookieConsentDialog as FunctionComponent })
ReactOnRails.register({ "AmexDone": AmexDone as FunctionComponent })

window.socialSharer = (url, description, type) => {

    const URLObjToParams = (obj) => {
        var url = obj.protocol + '://' + obj.base + obj.path + '?';
        for (let p in obj.params) {
            var param = obj.params[p];
            url += p + '=' + encodeURIComponent(param) + '&';
        }
        url = url.substring(0, url.length - 1);
        return url;
    }

    var shareUrl = '';

    if (type == 'facebook') {
        window.dataLayer.push({refer_a_friend_social: "facebook"})
        shareUrl = URLObjToParams({
            protocol: 'https',
            base: 'www.facebook.com',
            path: '/sharer/sharer.php',
            params: {
                u: url,
            }
        });

    } else if (type == 'twitter') {
        window.dataLayer.push({refer_a_friend_social: "twitter"})
        shareUrl = URLObjToParams({
            protocol: 'https',
            base: 'twitter.com',
            path: '/intent/tweet',
            params: {
                url: url,
                hashtags: 'Readly',
                text: description
            }
        });

    } else if (type == 'googleplus') {

        shareUrl = URLObjToParams({
            protocol: 'https',
            base: 'plus.google.com',
            path: '/share',
            params: {
                url: url,
            }
        });

    } else if (type == 'linkedin') {
        window.dataLayer.push({refer_a_friend_social: "linkedin"})
        shareUrl = URLObjToParams({
            protocol: 'https',
            base: 'www.linkedin.com',
            path: '/shareArticle',
            params: {
                url: url,
                mini: 'true',
                title: 'Sign up for Readly',
                summary: description,
                source: '',
            }
        });

    } else if (type == 'pinterest') {

        shareUrl = URLObjToParams({
            protocol: 'https',
            base: 'pinterest.com',
            path: '/pin/create/button',
            params: {
                url: 'imgurl',
                media: 'img',
                description: 'Summary',
            }
        });
        // var base = 'https://pinterest.com/pin/create/button/?url=imgurl&media=img&description=Description'
        // shareUrl = base.replace('%{shareurl}', url);
    }

    // var winTop = (screen.height / 2) - (winHeight / 2);
    // var winLeft = (screen.width / 2) - (winWidth / 2);
    var height = 400;
    var width = 640;
    var left = (screen.width / 2) - (width / 2);
    var top = (screen.height / 2) - (height / 2);
    window.open(shareUrl, 'Share', 'height=' + height + ', width=' + width + ', top=' + top + ', left=' + left + ' toolbar=no, menubar=no, scrollbars=no, resizable=no, location=no, directories=no, status=no');

    return shareUrl;
}

import './application_minimal'